import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import { MARKETING, SALES } from 'self-service-api/constants/ProductLines';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { useAppSelector } from '../../reducers';
import { bundleProductForBundleTypeAndProductLevelSelector, currentSkuIdForProductSelector, isSalesOrServiceProOrEntSkuSelector, quantityPackForProductVersionSelector, skuSelector } from '../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../selectors/SelectorUtils';
// Cannot be used with a sku with multiple quantityPacks
export const useSkuAdditionalUnits = ({
  productLevel,
  productLine,
  bundleType
}) => {
  const skuId = useAppSelector(state => {
    if (bundleType) {
      const bundleProduct = bundleProductForBundleTypeAndProductLevelSelector(state, {
        bundleType,
        productLevel
      });
      return bundleProduct === null || bundleProduct === void 0 ? void 0 : bundleProduct.currentSkuId;
    }
    return currentSkuIdForProductSelector(state, {
      productLine,
      productLevel
    });
  });
  const isSeatsUngated = usePricingLibSelector(getIsUngatedForSeats);
  const quantityPackSku = useAppSelector(state => {
    if (!skuId || !productLine) {
      return undefined;
    }
    return quantityPackForProductVersionSelector(state, {
      productVersionSkuId: skuId,
      quantityPackApiName: productLine === MARKETING || bundleType === MARKETING_PLUS_SUITE ? 'additional-marketing-contacts' : productLine === SALES ? 'additional-sales-seats' : 'additional-service-seats'
    });
  });
  const additionalUnitSkuId = useSelector(state => {
    if (!skuId || !productLine) {
      return;
    }
    const isSkuQuantifiable = skuSelector(state, {
      skuId
    }).quantifiable;
    if (isSalesOrServiceProOrEntSkuSelector(state, {
      skuId
    }) && isSkuQuantifiable && isSeatsUngated) {
      return skuId;
    } else {
      return quantityPackSku === null || quantityPackSku === void 0 ? void 0 : quantityPackSku.skuId;
    }
  });
  const quantityPackApiName = quantityPackSku === null || quantityPackSku === void 0 ? void 0 : quantityPackSku.quantityPackApiName;
  const isAdditionalUnitSkuIdAQuantityPack = useSelector(state => {
    if (!additionalUnitSkuId) {
      return false;
    }
    const {
      skuType
    } = skuSelector(state, {
      skuId: additionalUnitSkuId
    });
    return skuType === QUANTITY_PACK;
  });
  const [additionalUnitQuantity, setAdditionalUnitQuantity] = useState(0);
  return {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    setAdditionalUnitQuantity,
    quantityPackApiName,
    skuId
  };
};